import type { PatientBookingRequest, PatientBookingResponse } from '../api/generated';
import { PATIENT_BOOKING_TYPE } from '../components/PatientBookings/patientBookingConstants';
import { useBookings } from './useBookings';
import type { UseBookingsResult } from './useBookings';

export type UsePatientBookingsResult = UseBookingsResult<
  PatientBookingRequest,
  PatientBookingResponse
>;

export function usePatientBookings(locationId: string | null): UsePatientBookingsResult {
  return useBookings<PatientBookingRequest, PatientBookingResponse>(
    PATIENT_BOOKING_TYPE,
    locationId
  );
}
